// extracted by mini-css-extract-plugin
export default {"btn":"CollectionBtn_btn__FRvig","icon":"CollectionBtn_icon__g7zqZ"};